import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import mediaLogo from '../components/layout/Media_Logo.png';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const { login } = useAuth();
  const navigate = useNavigate();

  const masterPortalUrl = process.env.REACT_APP_MASTER_PORTAL_URL || "http://localhost:5173";

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = masterPortalUrl;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [masterPortalUrl]);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate('/jobs');
    } catch {
      // error toast handled by axios interceptor
    } finally { setLoading(false); }
  };

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      <div style={{ flex: 1, background: '#0f74b9', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 40, textAlign: 'center' }}>
        <img
          src={mediaLogo}
          alt="Delta Media"
          style={{ height: 88, width: 'auto', maxWidth: 120, objectFit: 'contain', display: 'block' }}
        />
        <div style={{ color: '#fff', marginTop: 20 }}>
          <div style={{ fontSize: 20, fontWeight: 700, letterSpacing: 1 }}>DELTA MEDIA</div>
          <div style={{ fontSize: 11, opacity: .75, marginTop: 5, letterSpacing: .5 }}>Creative Management System</div>
        </div>
        <p style={{ color: 'rgba(255,255,255,.6)', fontSize: 12, marginTop: 28, maxWidth: 220, lineHeight: 1.8 }}>
          Track creative jobs, manage workflows and collaborate — all in one place.
        </p>
      </div>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 40 }}>
        <div style={{ width: '100%', maxWidth: 360 }}>
          <div style={{
            marginBottom: 24,
            padding: 16,
            backgroundColor: '#fff7ed',
            border: '1px solid #ffedd5',
            borderRadius: 8,
            color: '#9a3412',
            fontSize: '13px',
            textAlign: 'center'
          }}>
            <p style={{ fontWeight: 600, marginBottom: 4 }}>Please login through the Master Portal</p>
            <p style={{ opacity: 0.8, marginBottom: 8 }}>Redirecting in {countdown} seconds...</p>
            <a href={masterPortalUrl} style={{ color: '#0f74b9', textDecoration: 'underline' }}>
              Go to Master Portal now
            </a>
          </div>
          <div style={{ fontSize: 10, fontWeight: 600, color: '#0f74b9', letterSpacing: .8, textTransform: 'uppercase', marginBottom: 4 }}>Welcome back</div>
          <h2 style={{ fontSize: 20, fontWeight: 600, color: '#343a40', marginBottom: 4 }}>Sign in to your account</h2>
          <p style={{ fontSize: 12, color: '#6c757d', marginBottom: 22 }}>Enter your credentials to continue</p>

          <form onSubmit={handleSubmit} style={{ display: 'none' }}>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#495057', marginBottom: 5 }}>Email address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                style={{ width: '100%', padding: '8px 10px', border: '1px solid #ced4da', borderRadius: 6, fontSize: 13, color: '#343a40' }}
                placeholder="you@deltamedia.in" />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#495057', marginBottom: 5 }}>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                style={{ width: '100%', padding: '8px 10px', border: '1px solid #ced4da', borderRadius: 6, fontSize: 13, color: '#343a40' }}
                placeholder="••••••••" />
            </div>
            <button type="submit" disabled={loading}
              style={{ width: '100%', padding: 10, background: '#0f74b9', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, fontWeight: 500, cursor: 'pointer', opacity: loading ? .7 : 1 }}>
              {loading ? 'Signing in…' : 'Sign In →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
